<template>
  <div id="rwa_collection_div" class="rwa_collection_div">

    <div class="rwa_collection_page_01">
      <Menu/>
    </div>

    <div id="rwa_collection_page_02" ref="rwa_collection_page_02" class="rwa_collection_page_02">

      <div class="rwa_collection_page_021">
        <img class="rwa_collection_page_021_bj01" src="../../assets/images/Ellipse_bjl.png"/>
        <img class="rwa_collection_page_021_bj03" src="../../assets/images/Ellipse_bjr.png"/>

        <div class="rwa_collection_page_021s">
          <div class="rwa_collection_page_0211" @click="toIndex()">
            <img src="../../assets/images/fhui.png"/>
            <div>{{ lang('home') }}</div>
          </div>

          <div class="rwa_collection_page_0212" v-if="myProjectList.length > 0">

            <div class="rwa_collection_info" v-for="(obj, index) in myProjectList" :key="index">
              <div class="rwa_collection_info_01">
                <img :src="imgHost + obj.images_group1[0]"/>
              </div>
              <div class="rwa_collection_info_02">
                <div class="rwa_collection_info_021">{{ obj.name }}</div>
                <div class="rwa_collection_info_022">
                  <div class="rwa_collection_info_0221">
                    <span>购买价格</span>
                    <div>{{ setDecimal(obj.final_price / 1e18, 6) }} BNB</div>
                  </div>
                  <div class="rwa_collection_info_0222">
                    <span>购买时间</span>
                    <div>{{ toTextDate(obj.won_at, false) }}</div>
                  </div>
                </div>
                <div v-if="obj.status === 'launched'" class="rwa_collection_info_023" style="background: #999; cursor: not-allowed;">兑换真实古董</div>
                <div v-if="obj.status === 'launched'" class="rwa_collection_info_024" style="color: #999; border: 1px solid #999; cursor: not-allowed">已发射到Pancake</div>

                <div v-if="obj.status !== 'launched'" class="rwa_collection_info_023" @click="toPushPancake(1, null)">兑换真实古董</div>
                <div v-if="obj.status !== 'launched'" class="rwa_collection_info_024" @click="toPushPancake(2, obj.project_id)">发射到Pancake</div>
              </div>
            </div>

          </div>

          <div class="rwa_collection_page_0213" v-if="myProjectList.length === 0">
            No Collectibles...
          </div>

        </div>
      </div>

      <div class="rwa_collection_page_03">
        <Bottom/>
      </div>
    </div>

    <el-dialog
        :visible.sync="colDialogVisible"
        width="500px"
        :show-close="false">
      <div class="rwa_collection_dialog">
        <div class="rwa_collection_dialog_01">
          <div>{{ collectionType === 1 ? '兑换真实古董' : '发射到Pancake' }}</div>
          <img src="../../assets/images/guanbi.png" @click="handleColClose()"/>
        </div>
        <div class="rwa_collection_dialog_02">
          {{collectionType === 1
            ?
            '请联系我们官方客服，我们将为你兑换真实古董；联系方式：XXXXXXX'
            :
            '选择发射到Pancake，我们将为这个代币在Pancake添加LP，LP内包含2亿个代币和价值2万U的BNB，添加完成后，LP权限和剩余8亿代币将自自动转入到你的地址；如确认发射请联系我们官方客服：XXXXXXX'
          }}
        </div>
        <div class="rwa_collection_dialog_03">
          <div class="rwa_collection_dialog_031" @click="handleColClose()">取消</div>
          <div class="rwa_collection_dialog_032" v-if="collectionType === 1" @click="handleColClose()">确定兑换真实古董</div>
          <div class="rwa_collection_dialog_032" v-if="collectionType === 2" @click="handleColClose()">确定发射到Pancake</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  cutAccount,
  lang,
  BigNumber,
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub
} from '../../tools/index';

import transfer from "../../tools/transfer";
import Menu from "../../components/Menu";
import Bottom from "../../components/Bottom";
import * as metaMaskTools from "../../tools/chain";

import {
  debug,
  uploadHost
} from "@/config";
import { mixin1 } from "@/tools/mixins";
import {setDecimal, toTextDate} from "@/tools/toolUtils";

export default {
  name: "Collection",
  components: { Menu, Bottom },
  mixins: [mixin1],
  data() {
    return {
      imgHost: uploadHost,
      colDialogVisible: false,
      myProjectList: [],
      collectionType: 1,
    };
  },
  created() {
    setTimeout(() => {
      this.onAccountsChanged();
    }, 1000);

    transfer.$on("initCollePageData", () => {
      this.initCollePageData();
    });
  },
  mounted() {
    this.initCollePageData();
  },
  watch: {
  },
  beforeDestroy() {
  },
  methods: {
    lang(key){
      return lang(key);
    },
    setDecimal(num, numDecimalMax) {
      return setDecimal(num, numDecimalMax, false, false);
    },
    toTextDate(timestamp, isAll) {
      if (isAll) {
        return toTextDate(timestamp).substr(0, 16);
      } else {
        return toTextDate(timestamp).substr(5, 11);
      }
    },
    async onRefresh(accounts) {
      await this.$store.commit('setState', {
        accounts
      });

      await this.initCollePageData();
    },
    async initRefreshNetwork() {
      await metaMaskTools.initParams().then(() => {});
    },
    initCollePageData() {
      try {
        if (this.$store.state.accounts.length > 0) {
          this.$http.getMyProjectList(this.$store.state.accounts[0]).then(res => {
            console.log("getMyProjectList: " + JSON.stringify(res));

            this.myProjectList = res.data;
          }).catch(err => {
            console.log(err);
          })
        } else {
          this.$message.warning('Please connect the wallet first!');
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleColClose() {
      this.colDialogVisible = false;
    },
    toPushPancake(num, id) {
      if (num === 1) {
        this.collectionType = num;

        this.colDialogVisible = true;
      } else if (num === 2) {
        this.$router.push({
          path: '/launchpad',
          query: {
            projectId: id
          }
        });
      }
    },
    toIndex() {
      transfer.$emit("toMenuPage", 1);
    }
  }
};
</script>

<style scoped lang="less">
.rwa_collection_div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .rwa_collection_page_01 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .rwa_collection_page_02::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .rwa_collection_page_02 {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 84px;
    bottom: 0;
    background: #151515;
    .rwa_collection_page_021 {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: flex-start;
      position: relative;
      .rwa_collection_page_021s {
        z-index: 1;
        margin-bottom: 100px;
        width: 70%;
        min-height: 700px;

        @media (max-width: 767px) {
          width: 90%;
        }
        .rwa_collection_page_0211 {
          z-index: 1;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: flex-start;
          margin: 100px 0 50px 0;
          cursor: pointer;
          img {
            width: 25px;
            margin-right: 20px;
          }
          div {
            color: #FFF;
            font-family: Montserrat;
            font-size: 26px;
            font-style: italic;
            font-weight: 900;
            line-height: 152%; /* 39.52px */
          }
        }
        .rwa_collection_page_0212 {
          z-index: 1;
          color: white;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-content: flex-start;
          justify-content: flex-start;
          align-items: center;
          .rwa_collection_info {
            display: flex;
            width: 580px;
            padding: 20px;
            justify-content: space-around;
            align-items: flex-start;
            gap: 20px;
            flex-shrink: 0;
            border-radius: 16px;
            border: 1px solid rgba(153, 153, 153, 0.3);
            background: #313131;
            flex-direction: row;
            flex-wrap: nowrap;
            margin: 0 25px 25px 0;

            @media (max-width: 767px) {
              justify-content: flex-start;
              align-items: center;
              flex-direction: column;
              width: 100%;
            }
            .rwa_collection_info_01 {
              @media (max-width: 767px) {
                width: 100%;
              }
              img {
                width: 300px;
                height: 200px;
                object-fit: cover;  /* 关键属性，保持比例并填充容器 */
                object-position: center;  /* 居中显示图片内容 */
                border-radius: 10px;

                @media (max-width: 767px) {
                  width: 100%;
                  height: auto;
                }
              }
            }
            .rwa_collection_info_02 {
              display: flex;
              flex-direction: column;
              flex-wrap: nowrap;
              justify-content: space-around;
              align-items: flex-start;
              height: 188px;

              @media (max-width: 767px) {
                width: 100%;
                height: 218px;
              }
              .rwa_collection_info_021 {
                color: #FFF;
                font-family: Roboto;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: 23px; /* 143.75% */
                border-bottom: 1px solid rgba(153, 153, 153, 0.3);
                height: 30px;

                @media (max-width: 767px) {
                  font-size: 20px;
                  width: 100%;
                }
              }
              .rwa_collection_info_022 {
                margin-bottom: 10px;
                .rwa_collection_info_0221 {
                  display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  justify-content: flex-start;
                  align-items: center;
                  span {
                    color: #999;
                    font-family: Inter;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    margin-right: 10px;

                    @media (max-width: 767px) {
                      font-size: 16px;
                    }
                  }
                  div {
                    color: #20B26C;
                    font-family: Inter;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;

                    @media (max-width: 767px) {
                      font-size: 16px;
                    }
                  }
                }
                .rwa_collection_info_0222 {
                  display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  justify-content: flex-start;
                  align-items: center;
                  span {
                    color: #999;
                    font-family: Inter;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    margin-right: 10px;

                    @media (max-width: 767px) {
                      font-size: 16px;
                    }
                  }
                  div {
                    color: #FFF;
                    font-family: Inter;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;

                    @media (max-width: 767px) {
                      font-size: 16px;
                    }
                  }
                }
              }
              .rwa_collection_info_023 {
                display: flex;
                padding: 8px 15px;
                justify-content: center;
                align-items: center;
                gap: 10px;
                align-self: stretch;
                border-radius: 8px;
                background: #20944B;
                cursor: pointer;

                @media (max-width: 767px) {
                  height: 45px;
                  margin-bottom: 10px;
                }
              }
              .rwa_collection_info_024 {
                display: flex;
                padding: 8px 15px;
                justify-content: center;
                align-items: center;
                gap: 10px;
                align-self: stretch;
                border-radius: 8px;
                border: 1px solid #20944B;
                color: #20B26C;
                cursor: pointer;

                @media (max-width: 767px) {
                  height: 45px;
                }
              }
            }
          }
        }
        .rwa_collection_page_0213 {
          color: white;
          font-size: 26px;
          font-style: italic;
          font-weight: 900;
          text-align: center;
          margin-top: 180px;
        }
      }
      .rwa_collection_page_021_bj01 {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        height: 100%;
        max-height: 880px;
        @media (max-width: 767px) {
          max-height: 720px;
        }
      }
      .rwa_collection_page_021_bj03 {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 0;
        max-width: 60%;
        @media (max-width: 767px) {
          max-width: 45%;
          display: none;
        }
      }
    }
    .rwa_collection_page_03 {
      width: 100%;
    }
  }
}
</style>

<style>
.rwa_collection_dialog {
  @media (max-width: 767px) {
    zoom: 1.25;
  }
  .rwa_collection_dialog_01 {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    div {
      color: #FFF;
      font-family: Roboto;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px; /* 133.333% */
    }
    img {
      width: 25px;
      height: 25px;
      cursor: pointer;
    }
  }
  .rwa_collection_dialog_02 {
    color: #FFF;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
    margin: 20px 0;
  }
  .rwa_collection_dialog_03 {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    .rwa_collection_dialog_031 {
      display: flex;
      width: 140px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      border-radius: 4px;
      border: 1px solid #20B26C;
      background: rgba(0, 0, 0, 0.00);
      margin-right: 20px;
      color: #20B26C;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      cursor: pointer;
    }
    .rwa_collection_dialog_032 {
      display: flex;
      height: 50px;
      padding: 0 20px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex: 1 0 0;
      border-radius: 4px;
      background: #20B26C;
      color: #FFF;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
      cursor: pointer;
    }
  }
}

.el-dialog .el-dialog__body {
  border-radius: 12px !important;
  border: 2px solid rgba(158, 240, 26, 0.10) !important;
  background: linear-gradient(0deg, #242622 0%, #242622 100%), rgba(255, 255, 255, 0.05) !important;
  backdrop-filter: blur(4.9968414306640625px) !important;
}
</style>